import { render, staticRenderFns } from "./AddNewEmail.vue?vue&type=template&id=ca9d4cd8&scoped=true"
import script from "./AddNewEmail.vue?vue&type=script&lang=js"
export * from "./AddNewEmail.vue?vue&type=script&lang=js"
import style0 from "./AddNewEmail.vue?vue&type=style&index=0&id=ca9d4cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d4cd8",
  null
  
)

export default component.exports